import { render, staticRenderFns } from "./areaStatisticsChild2023.vue?vue&type=template&id=096e8c04&scoped=true&"
import script from "./areaStatisticsChild2023.vue?vue&type=script&lang=js&"
export * from "./areaStatisticsChild2023.vue?vue&type=script&lang=js&"
import style0 from "./areaStatisticsChild2023.vue?vue&type=style&index=0&id=096e8c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096e8c04",
  null
  
)

export default component.exports